import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/shared/ui/EmptyState';

interface ExternalToolsEmptyStateProps {
  categoryName?: string;
  height?: string | number;
}

export function ExternalToolsEmptyState({
  categoryName,
  height = '100%',
}: ExternalToolsEmptyStateProps) {
  const { t } = useTranslation('admin');

  const title = categoryName
    ? t('externalToolsWidget.externalToolsEmptyState.noToolsIn', { categoryName })
    : t('externalToolsWidget.externalToolsEmptyState.noExternalToolsAvailable');
  const description = categoryName
    ? t('externalToolsWidget.externalToolsEmptyState.externalToolsWillAppearHereInCategory')
    : t('externalToolsWidget.externalToolsEmptyState.externalToolsWillAppearHere');

  return (
    <EmptyState
      title={title}
      description={description}
      data-testid="external-tools-empty-state"
      height={height}
    />
  );
}
